import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, X } from 'react-feather';
import { Capacitor } from '@capacitor/core';
import {
    GREENBERG_PROMO_DISMISS_KEY,
    GREENBERG_PROMO_QUERY,
    getGreenbergProductId,
    hasActiveGreenbergAccess,
} from '../../util/greenbergPromo';

const GreenbergPromoBanner = ({ user, subscriptions, userProperties }) => {
    const [dismissed, setDismissed] = useState(() => localStorage.getItem(GREENBERG_PROMO_DISMISS_KEY) === 'true');

    if (
        dismissed ||
        Capacitor.isNativePlatform() ||
        user?.admin ||
        user?.curator ||
        hasActiveGreenbergAccess(subscriptions, userProperties)
    ) {
        return null;
    }

    const dismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(GREENBERG_PROMO_DISMISS_KEY, 'true');
        setDismissed(true);
    }

    return (
        <div className="greenberg-promo-banner">
            <Link className="greenberg-promo-banner__link" to={`/checkout/${getGreenbergProductId()}?${GREENBERG_PROMO_QUERY}`}>
                <span>Get 20% off the improved Greenberg’s Handbook of Neurosurgery flashcards</span>
                <ArrowRight />
            </Link>
            <button className="greenberg-promo-banner__dismiss" onClick={dismiss} aria-label="Dismiss Greenberg discount banner">
                <X />
            </button>
        </div>
    );
}

export default GreenbergPromoBanner;
